import type { ShopDto, UpdateOneShopImportDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

type AddImportMethodParams = {
  shopImport: UpdateOneShopImportDto;
  importId: string;
};

export default function useUpdateImportMethod(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation(
    "patch",
    "/shops/{shopId}/imports/{importId}",
    {
      invalidate: invalidateShop,
      mapVariables: ({ shopImport, importId }: AddImportMethodParams) => ({
        params: { path: { shopId: shop.id, importId } },
        body: shopImport,
      }),
    },
  );
}
